import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import PreviewPage from '../../../components/Editor/PreviewPage';
import { getPageHtmlPath } from '../utils/helpers';
import UrlUtils from '../../../utils/url';

const mapStateToProps = (state: StoreState) => {
	const {
		routerParamsHistory,
		galleryInfos: { config },
		editor: {
			paths: { imagePath },
			slider: { page },
			pageZoom,
			version,
		},
	} = state;
	const { params: { resourceId } } = routerParamsHistory[routerParamsHistory.length - 1];

	return {
		src: UrlUtils.getEditorResourceUrl(config, +resourceId, `${getPageHtmlPath(imagePath, page)}?version=${version}`),
		zoom: pageZoom,
	};
};

export default connect(mapStateToProps)(PreviewPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/PreviewPage/index.tsx